import { ayantDroit } from "./Endpoints";
import axios from "axios";

export default {
  async onCreateAyantDroit(data, config) {
    const response = await axios.post(
      ayantDroit.OnPostAyantDroit(),
      data,
      config
    );
    return response.data;
  },
  async putAyantDroit(id, data, config) {
    const response = await axios.put(
      ayantDroit.onPutTypeAyantDroit(id),
      data,
      config
    );
    return response.data;
  },
  async onGetAyantDroitByBeneficiaire(id, config) {
    const response = await axios.get(
      ayantDroit.onGetAyantDroitByBeneficiaire(id),
      config
    );
    return response.data;
  },
  async deleteAyantDroit(id, config) {
    const response = await axios.delete(
      ayantDroit.onDeleteAyantDroit(id),
      config
    );
    return response;
  },
};
